import React from "react";
import useStyles from "./calendar-date-header.style";

interface MyLeaveCalendarDateHeaderProps {
  label: string;
}

export const MyLeaveCalendarDateHeader: React.FC<
  MyLeaveCalendarDateHeaderProps
> = ({ label }) => {
  const classes = useStyles();
  return (
    <div>
      <span className={classes.root}>{label}</span>
    </div>
  );
};

export default MyLeaveCalendarDateHeader;
